import React, { useMemo } from 'react';
import SaveIcon from '@mui/icons-material/Save';
import FilterListIcon from '@mui/icons-material/FilterList';

interface ViewButtonsConfig {
  onSaveView: () => void;
  onOpenSavedViews: () => void;
  loading?: boolean;
  disabled?: boolean;
}

interface ViewButton {
  variant: 'text' | 'contained';
  label: string;
  onClick: () => void;
  icon: React.ReactNode;
  disabled: boolean;
  tooltip?: string;
}

export const useViewButtons = (config: ViewButtonsConfig): ViewButton[] => {
  const {
    onSaveView,
    onOpenSavedViews,
    loading = false,
    disabled = false,
  } = config;

  const buttons = useMemo(() => {
    const isDisabled = loading || disabled;

    return [
      {
        variant: 'text' as const,
        label: 'Views',
        color: 'secondary',
        onClick: onOpenSavedViews,
        icon: <FilterListIcon />,
        disabled: isDisabled,
        tooltip: 'Load saved view configurations',
      },
      {
        variant: 'contained' as const,
        label: 'Save View',
        onClick: onSaveView,
        icon: <SaveIcon />,
        disabled: isDisabled,
        tooltip: 'Save current filters and settings',
      },
    ];
  }, [onSaveView, onOpenSavedViews, loading, disabled]);

  return buttons;
};

export default useViewButtons;
